export default __webpack_public_path__ + "f85a58b46d3990fbe541123f2d9ac837.svg";